import apiRoadmaps from "../../../api/roadmaps/apiRoadmaps";
import { RootState } from "@/store/redux/store";
import { useDispatch, useSelector } from "react-redux";
import { controlLoadingMap, IRoadmapWithPoints, setBoundsMap, setCityRoadmaps, setFormRoadmaps, setRoadmap, setRoadmaps, setVehTransports, setViewPortMapMode } from "../store/mapScreenSlce";
import { IRoadmap, IRoadmapMappoint } from "@/shared/types/roadmap";
import useToastMap from "./useToast";
import useBusstaitions from "./useBusstaitions";
import useTransport from "./useTransport";
import { getMapBoundsForRoadmap } from "../utils/map";
import { ICity } from "@/shared/types/city";
import { IRoute, IRouteSchedule } from "@/api/roadmaps/types";
import { formatDateDDMMYYYY } from "../../../utils/dateFunctions";
import { useEffect } from "react";

function useRoadmaps() {
    const dispatch = useDispatch();
    const { mapMode,
        city,
        busStation,
        busStationTo,
        busStations,
        roadmaps,
        cityRoadmaps,
        formRoadmaps,
        date,
    } = useSelector((state: RootState) => state.mapScreen);
    const { openToastMap, hideToastMap } = useToastMap();
    const { fillBusStationsByRoadmap } = useBusstaitions();
    const { fetchTransportById } = useTransport();

    function generateRoadmapeForStore(roadmap: IRoadmap, points: IRoadmapMappoint[]) {
        const data = { ...roadmap, roadmapPoints: points };
        return data;
    }

    useEffect(() => {
        const snapSnaphpt = date;
        if (snapSnaphpt && snapSnaphpt !== date) {

        }
    }, [date])

    async function selectRoadmapByBusStation(roadmap: IRoadmap, cityId?: string, transportType?: 'ТРАМВАЙ' | 'АВТОБУС') {
        try {
            openToastMap('loading', 'Загрузка маршрута')
            const points = await fetchRoadmapPoins(roadmap.part_id.toString(), cityId || city.id.toString())
            const data = generateRoadmapeForStore(roadmap, points);
            //@ts-ignore
            if (!data.veh_type) {
                //@ts-ignore
                data.veh_type = transportType
            }
            await fillBusStationsByRoadmap(points, cityId, true, transportType)
            if (roadmap.tc_id && (city || cityId)) {
                const transport = await fetchTransportById({ NVEH_ID: roadmap.tc_id, NPART_ID: roadmap.part_id.toString(), NCITY_ID: cityId || city.id })
                dispatch(setVehTransports([transport]))
            }
            dispatch(setRoadmaps([data]));
            focusMapOnRoadmaps([data])
            //dispatch(setRoadmap(data));
        }
        catch (err) {
            console.log(err);
        } finally {
            hideToastMap();
        }
    }

    /** Получить маршруты ОП отправления - ОП прибытия/Нас пункт прибытия */
    async function selectBusStationCityRoadmaps(busStationId: number | string, idTo: number, isCityTo: boolean = true) {
        try {
            openToastMap('loading', 'Загрузка маршрутов')
            dispatch(controlLoadingMap('fetchRoadmaps'));
            const dateDDMMYYYY = formatDateDDMMYYYY(date);
            const res = await apiRoadmaps.getScheduleAndFAList(
                dateDDMMYYYY,
                busStationId,
                idTo,
                undefined,
                isCityTo ? 'city' : 'busStaition',
                city.id.toString(),
            )
            const routesForForm = transformRouteSchedulesToRoutesForm(res.data, city.id, '')
            dispatch(setFormRoadmaps(routesForForm));
            const roadmaps = transformToRoadmap(res.data)
            const promisesRoadmapsForStore = roadmaps.map(async (part) => {
                const points = await fetchRoadmapPoins(part.part_id.toString(), city.id.toString());
                return generateRoadmapeForStore(part, points);
            });
            const result = await Promise.all(promisesRoadmapsForStore);
            if (result.length > 0) {
                focusMapOnRoadmaps(result);
            }
            const points = result.map((result) => (result.roadmapPoints)).flat()
            fillBusStationsByRoadmap(points, city.id.toString(), true);

            if (mapMode === 'roadMaps') {
                dispatch(setRoadmaps(result));
            }
        }
        catch (err) {
            console.log(err);
        } finally {
            dispatch(controlLoadingMap('fetchRoadmaps'));
            hideToastMap();
        }
    }

    async function getRoadmapByPartId(partId: string, cityId: string): Promise<IRoadmapWithPoints[]> {
        try {
            openToastMap('loading', 'Загрузка маршрута')
            const points = await fetchRoadmapPoins(partId, cityId)
            const roadmap: IRoadmap = { part_id: Number(partId), tc_id: undefined };
            const data = generateRoadmapeForStore(roadmap, points);
            await fillBusStationsByRoadmap(points, city.id.toString(), true)
            if (roadmap && roadmap.tc_id && city) {
                const transport = await fetchTransportById({ NVEH_ID: roadmap.tc_id, NPART_ID: roadmap.part_id.toString(), NCITY_ID: city.id })
                dispatch(setVehTransports([transport]))
            }
            dispatch(setRoadmaps([data]));
            focusMapOnRoadmaps([data])
            return [data];
        }
        catch (err) {
            console.log(err);
        } finally {
            hideToastMap();
        }
    }

    async function selectRoadmapByForm(NRL_ID: number, name?: string) {
        try {
            if (NRL_ID) {
                openToastMap('loading', 'Загрузка маршрута')
                if (NRL_ID !== 11) { //Отображение всех маршрутов если 11

                    const selectedRoadmap = cityRoadmaps.find((roadmap) => roadmap.id.toString() === NRL_ID.toString());

                    if (selectedRoadmap) {
                        const roadmapForStore = {
                            route_name: selectedRoadmap.name,
                            route_id: NRL_ID,
                        }
                        dispatch(setRoadmap(roadmapForStore));
                        await updateMapWithRoadmaps({ dataRoadmaps: [selectedRoadmap] });
                    }

                    // const res = await apiRoadmaps.getRoadmapsDirections(NRL_ID, city.id.toString());
                    // const roadmaps = res.r_parts.map((r) => {
                    //     const roadmapPoints = r.points.data.map((point) => {

                    //         return {
                    //             id: point[1],
                    //             latitude: point[5],
                    //             longitude: point[4],
                    //             is_stop: point[3],
                    //             stop_name: point[2],
                    //         }
                    //     })

                    //     const findedRoadmap = formRoadmaps.find((roadmap) => roadmap.id.toString() === r.id.toString());
                    //     return {
                    //         part_id: r.id,
                    //         route_id: NRL_ID,
                    //         route_name: findedRoadmap ? findedRoadmap.name : undefined,
                    //         roadmapPoints,
                    //     }
                    // })
                    // focusMapOnRoadmaps(roadmaps);
                    // fillBusStationsByRoadmap([...roadmaps[0].roadmapPoints, ...roadmaps[1].roadmapPoints], null, false)
                    // const roadmapForStore = {
                    //     route_name: name,
                    //     route_id: NRL_ID,
                    // }
                    // dispatch(setRoadmap(roadmapForStore));
                    // dispatch(setRoadmaps(roadmaps));
                } else { // если показать все маршруты из населенных пунктов 
                    await updateMapWithRoadmaps({ dataRoadmaps: cityRoadmaps })
                }
            }
        } catch (err) {
            console.log(err);
        }
        finally {
            hideToastMap();
        }
    }
    interface UpdateMapWithRoadmapsParams {
        dataRoadmaps: IRoute[];
        isRoadmapsShow?: boolean;
        cityId?: string;
        isFillStaitions?: boolean;
    }

    async function updateMapWithRoadmaps({
        dataRoadmaps,
        isRoadmapsShow = true,
        cityId,
        isFillStaitions = true,
    }: UpdateMapWithRoadmapsParams) {
        try {
            const promissesParts = dataRoadmaps.map(async (route) => {
                const dateFormated = formatDateDDMMYYYY(date);
                const res = await apiRoadmaps.getRoadmapsDirections(
                    route.id,
                    cityId ?? city.id.toString(),
                    dateFormated,
                ); // вернет айди направлений 
                const roadmapsParts = res.r_parts
                    //.filter((part) => directions.includes(part.direction)) // 0 - прямое направление, 1 - обратное фильтрация перенесена в рендере 
                    .map((part) => ({ ...part, route_name: route.name, route_id: route.id, veh_type: route.veh_type }))
                return roadmapsParts;
            })
            const roadmapsPartsGenerated = await Promise.allSettled(promissesParts)

            const roadmapsParts = roadmapsPartsGenerated.map((result) => {
                if (result.status === 'fulfilled') {
                    return result.value
                }
            }).flat()

            const promissesPointsParts = roadmapsParts.map(async (part) => {
                const res = await apiRoadmaps.getPoints(part.id.toString(), cityId ?? city.id.toString())
                const points = Object.values(res.points);
                return {
                    route_id: part.route_id,
                    part_id: part.id,
                    route_name: part.route_name,
                    roadmapPoints: points,
                    veh_type: part.veh_type,
                    route_direction: String(part.direction), // Convert to string
                };
            })
            const pointsGenerates = await Promise.allSettled(promissesPointsParts);

            const partsWithPoints = pointsGenerates.map((result) => {
                if (result.status === 'fulfilled') {
                    return result.value
                }
            })

            focusMapOnRoadmaps(partsWithPoints);
            const points = partsWithPoints.map((result) => (result.roadmapPoints)).flat()
            if (isFillStaitions) {
                fillBusStationsByRoadmap(points, null, true);
            }
            if (isRoadmapsShow) dispatch(setRoadmaps(partsWithPoints));
        }
        catch (err) {
            console.error('ошибка получения', err)
        }
    }

    /** Наполнить и получить маршруты между двумя городами */
    async function selectCityCityRoadmaps(idCityTo: number) {
        try {
            openToastMap('loading', 'Загрузка')
            dispatch(controlLoadingMap('fetchRoadmaps'))
            //if (formatDateDDMMYYYY(date) === formatDateDDMMYYYY(new Date().toString())) {
            const routesWithCitesTo = cityRoadmaps.filter((city) => city.routes_all_cities.includes(idCityTo.toString()));
            dispatch(setFormRoadmaps(routesWithCitesTo))
            await updateMapWithRoadmaps({ dataRoadmaps: routesWithCitesTo, isRoadmapsShow: mapMode === 'roadMaps' })
            //}
        }
        catch (err) {
            console.error(err)
        } finally {
            dispatch(controlLoadingMap('fetchRoadmaps'))
            hideToastMap();
        }
    }


    async function focusMapOnRoadmaps(roadpams: IRoadmapWithPoints[]) {
        const dataBounds = getMapBoundsForRoadmap(roadpams)
        dispatch(setViewPortMapMode('bounds'));
        dispatch(setBoundsMap({ values: dataBounds.bounds, options: dataBounds.options }));
    }

    async function getRoadmapsByBusstaition(busStationId?: string, cityId?: string): Promise<IRoadmap[]> {
        try {
            dispatch(controlLoadingMap('roadMaps'))
            const dateDDMMYYYY = formatDateDDMMYYYY(date);
            if ((busStationId || busStation) && (city || cityId)) {
                const res = await apiRoadmaps.get({
                    NCITY_ID: cityId || city.id.toString(),
                    NSTOP_ID: busStationId || busStation.id.toString(),
                    NONLY_LOWFLOOR: false,
                    dDATE: dateDDMMYYYY
                })
                const roadmaps: IRoadmap[] = [];
                Object.values(res.forecast).forEach((route) => {
                    roadmaps.push(route);
                })
                return roadmaps;
            }
        } catch (err) {
            console.log(err);
            alert('Ошибка при загрузке данных');
        } finally {
            dispatch(controlLoadingMap('roadMaps'))
        }
    }

    async function fetchRoadmapPoins(part_id: string, cityId: string): Promise<IRoadmapMappoint[]> {
        try {
            const res = await apiRoadmaps.getPoints(part_id, cityId.toString());
            const points = Object.values(res.points);
            return points;
        }
        catch (err) {
            console.log(err);
            alert('Ошибка при загрузке маршрута');
        }
    }

    async function showRoadmap(part_id: string, cityId: string) {
        const res = await apiRoadmaps.getPoints(part_id, cityId.toString());
        const points = Object.values(res.points);
    }

    async function getCityRoadmaps(cityId: ICity['id'] | string) {
        try {
            dispatch(controlLoadingMap('fetchRoadmaps'))
            const res = await apiRoadmaps.getByCity(cityId.toString());
            dispatch(setCityRoadmaps(Object.values(res.routes)));
            dispatch(setFormRoadmaps(Object.values(res.routes)));
            return Object.values(res.routes);
        }
        catch (err) {
            console.log(err)
        }
        finally {
            dispatch(controlLoadingMap('fetchRoadmaps'))
        }
    }

    async function fillRoadmapByQuery(cityId: string, routeId: string) {
        try {
            const roadmaps = await getCityRoadmaps(cityId);
            const selectedRoadmap = roadmaps.find((roadmap) => roadmap.id.toString() === routeId);

            if (selectedRoadmap) {
                const roadmapForStore = {
                    route_name: selectedRoadmap.name,
                    route_id: routeId,
                }
                dispatch(setRoadmap(roadmapForStore));
                await updateMapWithRoadmaps({ dataRoadmaps: [selectedRoadmap], isRoadmapsShow: true, cityId });
            }
        }
        catch (err) {
            console.log(err)
        }
    }

    async function selectCityRoadmaps() {
        if (cityRoadmaps) {
            dispatch(setRoadmaps([]));
            dispatch(setFormRoadmaps(cityRoadmaps));
        }
    }



    return {
        getRoadmapsByBusstaition,
        showRoadmap,
        selectRoadmapByBusStation,
        selectRoadmapByForm,
        getRoadmapByPartId,
        focusMapOnRoadmaps,
        selectCityRoadmaps,
        getCityRoadmaps,
        selectCityCityRoadmaps,
        selectBusStationCityRoadmaps,
        fillRoadmapByQuery,
    }

}

export default useRoadmaps;






// Функция для преобразования данных с сервера в нужный формат для вставки в форму
export const transformRouteSchedulesToRoutesForm = (
    serverRoutes: IRouteSchedule[],
    cityId: number,
    routesAllCities?: string
): IRoute[] => {
    return serverRoutes.map((route) => ({
        id: Number(route.route_id),
        name: `${route.route_access_name} ${route.route_name}`,
        access_name: route.route_access_name,
        veh_type: "АВТОБУС", // Здесь можно сделать маппинг типов транспорта, если есть данные
        city_id: cityId,
        routes_all_cities: routesAllCities,
        isPart: Boolean(route.r_parts_id), // Если есть r_parts_id, то это часть маршрута
    }));
};

const transformToRoadmap = (data: IRouteSchedule[]): IRoadmap[] => {
    return data.map((item) => ({
        route_id: Number(item.route_id),
        route_name: item.route_access_name, // Краткое название маршрута
        route_full_name: item.route_name, // Полное название маршрута
        route_direction: item.route_direction, // Прямое или Обратное
        part_id: Number(item.r_parts_id) || undefined, // ID части маршрута
        //veh_type: "АВТОБУС", // Тип транспорта
    }));
};